/**
 * 打开下载中心
 */
export const EVENT_OPEN_DOWNLOAD_CENTER = "openDownloadCenter";
